export default __webpack_public_path__ + "static/media/reportsActive.4ab6df0a.svg";